import React from 'react';
//import {  Nav, NavItem } from 'reactstrap';

function Header(props) {
  // console.log("HEADER:",props);
  return (
    <header>
      <div className="container header">
        <div className="row justify-content-center">
          <div className="col" align="center">
            <a href={props.portal.url} target="_blank" rel="noopener noreferrer">
              <img
                src={props.portal.imgUrlLogo}
                alt="Logo"
                className="img-fluid mx-auto p-4"
                style={{ maxWidth: "50%" }}
              />
            </a>
          </div>
        </div>
        <hr />
      </div>
    </header>
  );
}

export default Header;